import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CalculationService {
  private header: any = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
  private headerPdf: any = { headers: new HttpHeaders().set('Content-Type', 'application/json'), observe: 'response', responseType: 'arraybuffer' };

  // DEV
  private API_URI: string = '/life-protect-calc/calculator';

  // PROD
  // private API_URI: string = '../../mylife/calculator';

  constructor(private http: HttpClient) { }

  sendDataForCalculation(
    crill: string,
    secondMedOp: string,
    dateOfBirth: string,
    duration: number,
    manInsSum: number,
    currency: string,
    selectedPaymentType: number,
    acdt: string, //  'Y' -> Включено СМЪРТ ОТ ЗЛОПОЛУКА, 'N' -> Без СМЪРТ ОТ ЗЛОПОЛУКА
    ha: number, //  0 -> Без БОЛНИЧЕН ПРЕСТОЙ, 1 -> Включен БОЛНИЧЕН ПРЕСТОЙ ОТ ЗЛОПОЛУКА, 2 -> Включен БОЛНИЧЕН ПРЕСТОЙ ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
    me: number, //  0 -> Без РАЗХОДИ ЗА ЛЕКАРСТВА, 1 -> Включен РАЗХОДИ ЗА ЛЕКАРСТВА ОТ ЗЛОПОЛУКА, 2 -> Включен РАЗХОДИ ЗА ЛЕКАРСТВА ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
    temp: number, // 0 -> Без ВРЕМЕННА ЗАГУБА НА ТРУДОСПОСОБНОСТ,   1 -> Включена ВРЕМЕННА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА, 2 -> Включена ВРЕМЕННА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
    perm: number, //0 -> Без ТРАЙНА ЗАГУБА НА ТРУДОСПОСОБНОСТ, 1 -> Включен ТРАЙНА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА, 2 -> Включен ТРАЙНА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
  ) {
    let postData = {
      "pManInsSum": manInsSum,
      "pCrill": crill, // при включени тежки заболявания - "Y" or "N"
      "pSecMedOP": secondMedOp, // при включено второ медицинско мнение - - "Y" or "N"
      "pDateOfBirth": dateOfBirth, // "1994-03-15"
      "pDuration": duration,
      "pPremiumType": selectedPaymentType,
      "pCurrency": currency,
      "pHa": ha,
      "pMe": me,
      "pAcdt": acdt,
      "pTemp": temp,
      "pPerm": perm
    };
    return this.http.post( this.API_URI + '/calculate', JSON.stringify(postData), this.header );
  }

  sendDataForPDF(
    customPackage: string,
    crill: string,
    secondMedOp: string,
    dateOfBirth: string,
    duration: number,
    manInsSum: number,
    currency: string,
    selectedPaymentType: number,
    acdt: string, //  'Y' -> Включено СМЪРТ ОТ ЗЛОПОЛУКА, 'N' -> Без СМЪРТ ОТ ЗЛОПОЛУКА
    ha: number, //  0 -> Без БОЛНИЧЕН ПРЕСТОЙ, 1 -> Включен БОЛНИЧЕН ПРЕСТОЙ ОТ ЗЛОПОЛУКА, 2 -> Включен БОЛНИЧЕН ПРЕСТОЙ ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
    me: number, //  0 -> Без РАЗХОДИ ЗА ЛЕКАРСТВА, 1 -> Включен РАЗХОДИ ЗА ЛЕКАРСТВА ОТ ЗЛОПОЛУКА, 2 -> Включен РАЗХОДИ ЗА ЛЕКАРСТВА ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
    temp: number, // 0 -> Без ВРЕМЕННА ЗАГУБА НА ТРУДОСПОСОБНОСТ,   1 -> Включена ВРЕМЕННА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА, 2 -> Включена ВРЕМЕННА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
    perm: number, //0 -> Без ТРАЙНА ЗАГУБА НА ТРУДОСПОСОБНОСТ, 1 -> Включен ТРАЙНА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА, 2 -> Включен ТРАЙНА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
    manPrem: number, // стойността на вноската, върната от калкулатора
    userName: string,
    email: string,
    forEmail: boolean, // когато трябва да изпратим имейл с прикачен pdf
    forPrinting: boolean // когато трябва да принтираме pdf
  ) {
    let postData = {
      "customPackage": customPackage,
      "pManInsSum": manInsSum,
      "pCrill": crill, // при включени тежки заболявания - "Y" or "N"
      "pSecMedOP": secondMedOp, // при включено второ медицинско мнение - - "Y" or "N"
      "pDateOfBirth": dateOfBirth, // "1994-03-15"
      "pDuration": duration,
      "pPremiumType": selectedPaymentType,
      "pCurrency": currency,
      "pHa": ha,
      "pMe": me,
      "pAcdt": acdt,
      "pTemp": temp,
      "pPerm": perm,
      "pManPrem": manPrem,
      "userName": userName, // string
      "email": email// string
    };

    // Check user's choice - to send an email with attached pdf or to print a pdf
    if (forEmail) {
      return this.http.post( this.API_URI + '/pdf/send', JSON.stringify(postData), this.header );
    }
    else if (forPrinting) {
      return this.http.post( this.API_URI + '/pdf/print', JSON.stringify(postData), this.headerPdf );
    }
    else {
      return this.http.post( this.API_URI + '/pdf/send', JSON.stringify(postData), this.header );
    }
  }
}
